import { combineReducers } from "redux";

import get_property from "../features/admin/property/get_property/Slice";

import get_property_inquiry from "../features/admin/property/get_property_inquiry/Slice";

const Property = combineReducers({
  get_property,
  get_property_inquiry,
});

export default Property;
